// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__35UFe","header":"ClearentDisclaimer_header__1_tmB","inner":"ClearentDisclaimer_inner__BUFBU"};